const signUpHandler = async (service, data) => {
  const user = await service.post("/user/profile", data);
  return user;
};

export default signUpHandler;
